export const geneticsMethodsModuleOverview = [
  {
    id: "chromosome-dna",
    title: "Chromosome and DNA Analysis: Part 1",
    description: "Karyotyping & FISH.",
    icon: "🧪",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-300",
  },
  {
    id: "chromosome-dna-2",
    title: "Chromosome and DNA Analysis: Part 2",
    description: "DNA Microarrays (CGH- and SNP-Arrays).",
    icon: "🧪",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-300",
  },
  {
    id: "chromosome-dna-3",
    title: "Chromosome and DNA Analysis: Part 3",
    description: "PCR and gel electrophoresis.",
    icon: "🧪",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-300",
  },
  {
    id: "chromosome-dna-4",
    title: "Chromosome and DNA Analysis: Part 4",
    description: "Sanger-sequencing.",
    icon: "🧪",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-300",
  },
  {
    id: "chromosome-dna-5",
    title: "Chromosome and DNA Analysis: Part 5",
    description: "Next-generation sequencing (NGS).",
    icon: "🧪",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-300",
  },
  {
    id: "chromosome-dna-6",
    title: "Chromosome and DNA Analysis: Part 6",
    description: "Long-read sequencing, Triplet-Primed PCR, NIPT.",
    icon: "🧪",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-300",
  },
  {
    id: "methylation",
    title: "Methylation Analysis",
    description: "Bisulfite-Seq and MeDIP-Seq.",
    icon: "🧬",
    gradient: "from-emerald-100 via-teal-50 to-cyan-100 border-teal-300",
  },
  {
    id: "rna",
    title: "RNA Analysis",
    description: "qPCR (RT-PCR) and RNA-sequencing.",
    icon: "🧫",
    gradient: "from-amber-100 via-yellow-50 to-orange-100 border-amber-300",
  },
  {
    id: "protein",
    title: "Protein Analysis",
    description: "Western blot and ChIP-Seq, CUT&RUN and CUT&Tag.",
    icon: "⚗️",
    gradient: "from-pink-100 via-rose-50 to-fuchsia-100 border-pink-300",
  },
];
